import { WaardelijstFactory } from "../factories";

const REDENINTREKKINGVERVANGING = "plooi:RedenIntrekkingVervanging";
const ONDERWERPEN_RONL = "rijksoverheid.nl:onderwerp";
const TAAL = "eu:Taal";
const INFORMATIECATEGORIEEN = "woo:Informatiecategorie";
const MINISTERIE = "overheid:Ministerie";
const ZELFSTANDIGEBESTUURSORGANEN = "overheid:ZelfstandigeBestuursorganen";
const SAMENWERKINGSORGANISATIES = "overheid:SamenwerkingOrganisaties";
const OVERIGEOVERHEIDORGANISATIES = "overheid:AndereOrganisatie";
const GEMEENTENORGANISATIES = "overheid:Gemeente";
const PROVINCIESORGANISATIES = "overheid:Provincie";
const WATERSCHAPPENORGANISATIES = "overheid:Waterschap";

export class WaardelijstenApi {
  private readonly wlFactory: WaardelijstFactory;
  private readonly baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.REACT_APP_DICTIONARY_API}`;
    this.wlFactory = new WaardelijstFactory();
  }

  private readonly getWaardelijst = (subject: string, fallbackResponse: any) =>
    fetch(`${this.baseUrl}/${subject}`)
      .then((response: Response) => response.json())
      .then(this.wlFactory.createFromTooi)
      .catch(() => fallbackResponse);

  public getRedenIntrekkingVervanging = () =>
    this.getWaardelijst(REDENINTREKKINGVERVANGING, this.wlFactory.createRedenLijst().at(0)?.children);
  public getRonlOnderwerpen = () =>
    this.getWaardelijst(
      ONDERWERPEN_RONL,
      this.wlFactory.createFromTooi(require("../assets/waardelijsten/onderwerpen_ronl.json"))
    );
  public getInformatiecategorieen = () =>
    this.getWaardelijst(INFORMATIECATEGORIEEN, this.wlFactory.createInformatiecategorieenLijst());
  public getZelfstandigeBestuurorganen = () =>
    this.getWaardelijst(ZELFSTANDIGEBESTUURSORGANEN, this.wlFactory.createZelfstandigeBestuurorganenLijst());
  public getSamenwerkingsOrganisaties = () =>
    this.getWaardelijst(SAMENWERKINGSORGANISATIES, this.wlFactory.createSamenwerkingsOrganisatiesLijst());
  public getOverigeOrganisaties = () =>
    this.getWaardelijst(OVERIGEOVERHEIDORGANISATIES, this.wlFactory.createOverigeOrganisatiesLijst());
  public getGemeentenOrganisaties = () =>
    this.getWaardelijst(GEMEENTENORGANISATIES, this.wlFactory.createGemeentenOrganisatiesLijst());
  public getProvinciesOrganisaties = () =>
    this.getWaardelijst(PROVINCIESORGANISATIES, this.wlFactory.createProvinciesOrganisatiesLijst());
  public getWaterschappenOrganisaties = () =>
    this.getWaardelijst(WATERSCHAPPENORGANISATIES, this.wlFactory.createWaterschappenOrganisatiesLijst());
  public getMinisterie = () => this.getWaardelijst(MINISTERIE, this.wlFactory.createMinisterieLijst());
  public getTaal = () => this.getWaardelijst(TAAL, this.wlFactory.createTaalLijst());
}
